import { StringMap } from '@/shared/utils/map'

export function setProperty(result: StringMap<any>, selector: string | string[], value: any): void {
  const path: string[] = typeof selector === 'string' ? selector.split('.') : selector
  const part = path[0]

  if (path.length > 1) {
    if (result[part] === undefined) {
      result[part] = {}
    }

    setProperty(result[part], path.slice(1), value)
  } else {
    result[part] = value
  }
}
